/* eslint @typescript-eslint/default-param-last: 0 */
import styled from '@emotion/styled';
import setMargin from '../../../helpers/set-margin';

export const decideBackgroundActive = ({
  theme,
  disabled
}) => {
  if (disabled) {
    return `${theme.colors.neutral.shades.shade50}`;
  } else {
    return `${theme.colors.primary.shades.shade100}`;
  }
};

export const decideBackgroundHover = (
  theme,
  disabled
) => {
  if (disabled) {
    return `${theme.colors.neutral.shades.shade50}`;
  } else {
    return `${theme.colors.primary.shades.shade700}`;
  }
};

export const NavButton = styled('button')`
  ${setMargin};
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center !important;
  width: ${({ width }) => width || '100% !important'};
  color: ${({ theme }) => theme.colors.white};
  position: relative;
  background: ${({ theme }) => theme.colors.primary.main};
  border: none;
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  font-size: 1rem;
  letter-spacing: 0.04rem;
  padding: 20px;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  transition:
    background-color 300ms linear,
    color 300ms linear;

  /* clicking style */
  :active {
    color: ${({ disabled }) => disabled ? 'rgba(250, 249, 251, 0.08)' : 'rgba(250, 249, 251, 0.24)'}
  }

  :hover {
    background: ${({ disabled }) => disabled ? 'rgba(250, 249, 251, 0.08)' : 'rgba(250, 249, 251, 0.16)'};
  }

  :focus {
    background: ${({ disabled }) => disabled ? 'rgba(250, 249, 251, 0.08)' : 'rgba(250, 249, 251, 0.16)'};
    box-shadow: 0px 0px 0px 2px #B2F2F9;
    border-radius: 4px;
  }

  :focus-visible {
    outline: none;
  }

  /* for disabled style */
  opacity: ${({ disabled, loading }) => (disabled || loading ? 0.5 : 1)};

  cursor: ${({ disabled, loading }) =>
    disabled || loading ? 'not-allowed' : 'pointer'};
`;

export const InnerTextAlign = styled.span`
  padding-top: 0px;
  line-height: ${(icon) => icon && 'normal'}
`;
